import { css } from '@emotion/react';

const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 56px 0;
  flex: 1;

  @media (max-width: 1169px) {
    padding: 48px 16px;
  }
`;

const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1140px;
  max-width: 100%;
`;

const tabs = css`
  display: flex;
  gap: 24px;
`;

const tab = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 28.6px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

const tabActive = css`
  ${tab};
  color: #241a17;
`;

const tabInactive = css`
  ${tab};
  color: rgba(61, 46, 41, 0.52);
`;

const actions = css`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const textButton = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 8px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #251b18;
  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const newButton = css`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding: 0 17px;
  border: none;
  border-radius: 6px;
  background: #251b18;
  color: #f8f7f7;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    background: #2a2a28;
  }
  svg {
    color: #a39a97;
  }
`;

const tableContainer = css`
  display: flex;
  flex-direction: column;
  width: 1140px;
  max-width: 100%;
`;

const tableRow = css`
  display: grid;
  grid-template-columns: 1.5fr 110px 110px 100px 1fr;
  align-items: center;
  height: 64px;
  border-bottom: 1px solid rgba(60, 50, 47, 0.12);
  gap: 16px;
`;

const headerRow = css`
  display: grid;
  grid-template-columns: 1.5fr 110px 110px 100px 1fr;
  align-items: center;
  height: 36px;
  gap: 16px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #241a17;
`;

const subscriberCell = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const email = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #241a17;
`;

const emailMuted = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: rgba(57, 48, 45, 0.52);
`;

const cellText = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #241a17;
`;

const mutedText = css`
  ${cellText};
  color: rgba(57, 48, 45, 0.52);
`;

const badgeBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 112px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
`;

const badgeActive = css`
  ${badgeBase};
  background: #dcf2cf;
  color: #1f4002;
`;

const badgeUnsubscribed = css`
  ${badgeBase};
  background: #f3f2f1;
  color: rgba(61, 46, 41, 0.52);
`;

const segments = css`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
`;

const segmentBadge = css`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 112px;
  background: #f3e8e8;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #241a17;
  white-space: nowrap;
`;

const segmentBadgeAlt = css`
  ${segmentBadge};
  background: #fce8e0;
`;

const segmentMore = css`
  ${segmentBadge};
  background: #f3e8e8;
`;

const subscribers = [
  { id: 97, email: 'yuri+97@flodesk.com', status: 'unsubscribed', date: 'Apr 20', sales: '—' },
  { id: 98, email: 'yuri+98@flodesk.com', status: 'unsubscribed', date: 'Apr 9', sales: '—' },
  { id: 100, email: 'yuri+100@flodesk.com', status: 'unsubscribed', date: 'Apr 8', sales: '—' },
  { id: 99, email: 'yuri+99@flodesk.com', status: 'unsubscribed', date: 'Apr 8', sales: '—' },
  { id: 96, email: 'yuri+96@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
  { id: 95, email: 'yuri+95@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
  { id: 94, email: 'yuri+94@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
  { id: 93, email: 'yuri+93@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
  { id: 92, email: 'yuri+92@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
  { id: 91, email: 'yuri+91@flodesk.com', status: 'active', date: 'Sep 11, 2024', sales: '—' },
];

export default function AudienceView() {
  return (
    <div css={wrapper}>
      <div css={header}>
        <div css={tabs}>
          <button css={tabActive} type="button">
            All subscribers
          </button>
          <button css={tabInactive} type="button">
            Customers
          </button>
          <button css={tabInactive} type="button">
            Segments
          </button>
        </div>
        <div css={actions}>
          <button css={textButton} type="button">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" strokeWidth="1.5" />
              <path
                d="M12 12L16.5 16.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            Search
          </button>
          <button css={textButton} type="button">
            Sort
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
              <path
                d="M1 7L5 11L9 7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button css={textButton} type="button">
            Filter
          </button>
          <button css={newButton} type="button">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1V13M1 7H13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            Add subscriber
          </button>
        </div>
      </div>

      <div css={tableContainer}>
        <div css={headerRow}>
          <div>Subscriber</div>
          <div>Status</div>
          <div>Last activity</div>
          <div>Total sales</div>
          <div style={{ textAlign: 'right' }}>Segments</div>
        </div>
        {subscribers.map(s => (
          <div key={s.id} css={tableRow}>
            <div css={subscriberCell}>
              <span css={email}>{s.email}</span>
              <span css={emailMuted}>{s.email.replace('@flodesk.com', '')} @flodesk.com</span>
            </div>
            <div>
              <span css={s.status === 'active' ? badgeActive : badgeUnsubscribed}>
                {s.status === 'active' ? 'Active' : 'Unsubscribed'}
              </span>
            </div>
            <div css={cellText}>{s.date}</div>
            <div css={mutedText}>{s.sales}</div>
            <div css={segments}>
              <span css={segmentBadge}>Test test test</span>
              <span css={segmentBadgeAlt}>Monthly product design</span>
              <span css={segmentMore}>+4</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
